module.exports = __webpack_public_path__ + "static/img/anquanlvsezhengban2.5090e0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/anquanlvsezhengban2.png
// module id = 50Tg
// module chunks = 31